import { Component, type ErrorInfo, type ReactNode } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  failed: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { failed: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error('The Paradox app render failure', error, info)
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="fatal-state">
          <p className="fatal-state__eyebrow">SYSTEM / RECOVERY</p>
          <h1>That route hit a wall.</h1>
          <p>Your saved tour data is still on this device. Reload the app to try again.</p>
          <button className="fatal-state__action" onClick={() => window.location.reload()} type="button">Reload app</button>
        </main>
      )
    }
    return this.props.children
  }
}
